<template>
  <div>
    <div class="vx-row">
      <div class="vx-col w-full mb-base">
        <vx-card title="">
          <div class="demo-alignment">
            <vs-input
              class="inputx"
              placeholder="Arama..."
              @keyup.enter="faturaList()"
              :ref="faturaAra"
              v-model="faturaAra"
            />

            
            <vs-button
              @click="faturaList()"
              id="button-with-loading"
              class="vs-con-loading__container"
              color="primary"
              style="border-radius: 5px; height: 40px"
              type="gradient"
              >Listele</vs-button
            >
            <NetsisFaturaAktarimComponent
              :secilenFatura="secilenFatura"
              :program="muhname"
              :denemeMet="denemeMet"
            />
          </div>
        </vx-card>
      </div>

      <div class="vx-col lg:w-3/12" style=""></div>
    </div>

    <vue-good-table
      @on-selected-rows-change="selectionChanged"
      :columns="columns"
      :rows="faturaListesi"
      :rtl="dir"
      :select-options="{
        enabled: true,
        selectOnCheckboxOnly: true, // only select when checkbox is clicked instead of the row
        selectionInfoClass: 'custom-class',
        selectionText: 'rows selected',
        clearSelectionText: 'clear',
        disableSelectInfo: true, // disable the select info panel on top
        selectAllByGroup: true, // when used in combination with a grouped table, add a checkbox in the header row to check/uncheck the entire group
      }"
      :pagination-options="{
        enabled: true,
        perPage: pageLength,
      }"
    >
      <template slot="table-row" slot-scope="props">
        <!-- Column: Name -->
        <div v-if="props.column.field === 'CARIADI'" class="text-nowrap">
          <span class="text-nowrap">{{ props.row.CARIADI }}</span>
        </div>

        <!-- Column: Status -->
        <span v-else-if="props.column.field === 'status'">
          <b-badge :variant="statusVariant(props.row.status)">
            {{ props.row.status }}
          </b-badge>
        </span>

        <!-- Column: Common -->
        <span v-else>
          {{ props.formattedRow[props.column.field] }}
        </span>
      </template>

      <!-- pagination -->
      <template slot="pagination-bottom" slot-scope="props">
        <div class="d-flex justify-content-between flex-wrap">
          <div class="d-flex align-items-center mb-0 mt-1">
            <span class="text-nowrap"> Showing 1 to </span>
            <b-form-select
              v-model="pageLength"
              :options="['50', '100', '250', '500', '1000']"
              class="mx-1"
              @input="
                (value) => props.perPageChanged({ currentPerPage: value })
              "
            />
            <span class="text-nowrap"> of {{ props.total }} entries </span>
          </div>
          <div>
            <b-pagination
              :value="1"
              :total-rows="props.total"
              :per-page="pageLength"
              first-number
              last-number
              align="left"
              prev-class="prev-item"
              next-class="next-item"
              class="mt-1 mb-0"
              @input="(value) => props.pageChanged({ currentPage: value })"
            >
              <template #prev-text>
                <feather-icon icon="ChevronLeftIcon" size="18" />
              </template>
              <template #next-text>
                <feather-icon icon="ChevronRightIcon" size="18" />
              </template>
            </b-pagination>
          </div>
        </div>
      </template>
    </vue-good-table>
  </div>
</template>
<script>
import state from "../../store/state";
import Store from "../../store/store";
import NetsisFaturaAktarimComponent from "../components/uzum-components/topluislem-components/NetsisFaturaAktarimComponent.vue";
import {
  BAvatar,
  BBadge,
  BPagination,
  BFormGroup,
  BFormInput,
  BFormSelect,
  BDropdown,
  BDropdownItem,
} from "bootstrap-vue";
export default {
  data() {
    return {
      pageLength: 50,
      dir: false,
      muhname: "Netsis",
      faturaSelected: [],
      pazaryeriSelected: [],
      faturaListesi: [],
      secilenFatura: [],
      faturaAra: "",
      columns: [
        {
          label: "Cari Adı",
          field: "CARIADI",
        },
        {
          label: "Cari Kod",
          field: "CARI_KOD",
        },
        {
          label: "Açıklama",
          field: "BACIKLAMA",
        },
        {
          label: "Program",
          field: "EACIK9",
        },
        {
          label: "Gib Fatura No",
          field: "GIB_FATIRS_NO",
        },

        {
          label: "Genel Toplam",
          field: "GENELTOPLAM",
        },
        {
          label: "Tarih",
          field: "TARIH",
        },

        /*  {
          label: "Action",
          field: "action",
        },*/
      ],
    };
  },
  mounted() {
    this.$root.$on("faturaAktarimList", () => {
      // your code goes here
      this.faturaList();
    });
  },
  beforeDestroy() {
    this.$root.$off("faturaAktarimList");
  },
  components: {
    NetsisFaturaAktarimComponent,
    BAvatar,
    BBadge,
    BPagination,
    BFormGroup,
    BFormInput,
    BFormSelect,
    BDropdown,
    BDropdownItem,
  },
  methods: {
    denemeMet() {
      this.faturaList();
    },
    selectionChanged(params) {
      this.secilenFatura = params.selectedRows;
    },
    faturaList() {
      this.secilenFatura = [];
      var vm = this;
      var vs = this.$vs;

      const soap = require("soap");
      const url = state.sistemAddress;

      const args = {
        program: "Netsis",
      };

      soap.createClient(url, function (err, client) {
        client.faturaAktarListe(args, function (err, result) {
          if (result.faturaAktarListeResult == "-1") {
            Store.dispatch("logout");
            //this.$store.dispatch('login', payload)
          }

          vm.veriler = JSON.parse(result.faturaAktarListeResult);
          vm.faturaListesi = vm.veriler.jsonData;
          if (vm.veriler.response == "Ok") {
            /*  vs.notify({
              text: "Faturalar çekildi",
              iconPack: "feather",
              icon: "icon-alert-circle",
              color: "success",
              position: "top-center",
            });*/
          }
        });
      });
    },
  },
  created() {
    this.faturaList();
  },
};
</script>
<style lang="scss">
table.vgt-table {
  font-size: small;
}
</style>